import { API_ROUTES, request } from '../instance';

export const flag = (data: string[]) => {
  return request({
    url: `${API_ROUTES.needsReviewActions}/interest/flag`,
    method: 'POST',
    data,
  });
};

export const unMarkUnderReview = (data: string[]) => {
  return request({
    url: `${API_ROUTES.needsReviewActions}/unmark-under-review`,
    method: 'POST',
    data,
  });
};
